export default __webpack_public_path__ + "static/media/logout.f773748b.svg";